import React from 'react';
import { HomePage } from './pages/HomePage';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { CategoryPage } from './pages/CategoryPage';
import { ProductDetailPage } from './pages/ProductDetailPage';
import { DealerPage } from './pages/DealerPage';
import { LoginPage } from './pages/LoginPage';
import { Header } from './components/Header';
import { AdminDashboardLayout } from './components/admin/AdminDashboardLayout';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { SpuManagement } from './pages/admin/SpuManagement';
import { DealerDashboardLayout } from './components/dealer/DealerDashboardLayout';
import { DealerDashboard } from './pages/dealer/DealerDashboard';
import { OrdersManagement } from './pages/admin/OrdersManagement';
import { CouponsManagement } from './pages/admin/CouponsManagement';
import { SettingsPage } from './pages/admin/SettingsPage';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { UnauthorizedPage } from './pages/UnauthorizedPage';
import { CollectionManagement } from './pages/admin/CollectionManagement';
import { EnhancedOrderManagement } from './pages/admin/EnhancedOrderManagement';
import { SettlementsManagement } from './pages/admin/SettlementsManagement';
import { SettlementDetails } from './pages/admin/SettlementDetails';
import { InventoryManagement } from './pages/dealer/InventoryManagement';
export function App() {
  return <Router data-id="element-0">
      <AuthProvider data-id="element-1">
        <Routes data-id="element-2">
          {/* Public Routes */}
          <Route path="/" element={<div className="w-full min-h-screen bg-gray-50" data-id="element-4">
                <Header data-id="element-5" />
                <HomePage data-id="element-6" />
              </div>} data-id="element-3" />
          <Route path="/category/:categoryName" element={<div className="w-full min-h-screen bg-gray-50" data-id="element-8">
                <Header data-id="element-9" />
                <CategoryPage data-id="element-10" />
              </div>} data-id="element-7" />
          <Route path="/product/:productId" element={<div className="w-full min-h-screen bg-gray-50" data-id="element-12">
                <Header data-id="element-13" />
                <ProductDetailPage data-id="element-14" />
              </div>} data-id="element-11" />
          <Route path="/dealers" element={<div className="w-full min-h-screen bg-gray-50" data-id="element-16">
                <Header data-id="element-17" />
                <DealerPage data-id="element-18" />
              </div>} data-id="element-15" />
          <Route path="/login" element={<LoginPage data-id="element-20" />} data-id="element-19" />
          <Route path="/unauthorized" element={<UnauthorizedPage data-id="element-22" />} data-id="element-21" />
          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute requiredRole="admin" data-id="element-24">
                <AdminDashboardLayout data-id="element-25" />
              </ProtectedRoute>} data-id="element-23">
            <Route index element={<AdminDashboard data-id="element-27" />} data-id="element-26" />
            <Route path="products/spu" element={<SpuManagement data-id="element-29" />} data-id="element-28" />
            <Route path="products/collections" element={<CollectionManagement data-id="element-31" />} data-id="element-30" />
            <Route path="orders" element={<OrdersManagement data-id="element-33" />} data-id="element-32" />
            <Route path="enhanced-orders" element={<EnhancedOrderManagement data-id="element-35" />} data-id="element-34" />
            <Route path="collections" element={<CollectionManagement data-id="element-37" />} data-id="element-36" />
            <Route path="coupons" element={<CouponsManagement data-id="element-39" />} data-id="element-38" />
            <Route path="settlements" element={<SettlementsManagement data-id="element-41" />} data-id="element-40" />
            <Route path="settlements/:id" element={<SettlementDetails data-id="element-43" />} data-id="element-42" />
            <Route path="settings" element={<SettingsPage data-id="element-45" />} data-id="element-44" />
          </Route>
          {/* Dealer Routes */}
          <Route path="/dealer" element={<ProtectedRoute requiredRole="dealer" data-id="element-47">
                <DealerDashboardLayout data-id="element-48" />
              </ProtectedRoute>} data-id="element-46">
            <Route index element={<DealerDashboard data-id="element-50" />} data-id="element-49" />
            <Route path="inventory" element={<InventoryManagement data-id="element-52" />} data-id="element-51" />
            {/* Add more dealer routes here */}
          </Route>
        </Routes>
      </AuthProvider>
    </Router>;
}